export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TabDettaglioNote.vue?vue&type=template&id=6c5492b1&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/TabDettaglioNote.vue?vue&type=template&id=6c5492b1&
// module id = 780
// module chunks = 0